import {
    Row,
    Button,
    Col,
    Form
} from "react-bootstrap";
import { toast } from "react-toastify";
import { EmptyLocalStorage } from "../../services/auth/auth.service";
import { useForm } from 'react-hook-form';
import React, { useState } from 'react';
import Spinner from "react-bootstrap/Spinner";
import { useHistory } from "react-router-dom";
import {
  PostExportClientCSV,
} from "../../services/users.service";

const ExportClientCSVModalForm = () => {
    const { handleSubmit, register } = useForm({
        defaultValues: {
            signup_from: "",
            signup_to: "",
            client_status: "ALL",
            user_type: "ALL"
        }
    });
    const [disableDownload, setDisableDownload] = useState(false);
    const history = useHistory();

    const handleExportClientCSV = async (data) => {
        setDisableDownload(true);
        const creation_date_from = data.signup_from ? data.signup_from : null;
        const creation_date_to = data.signup_to ? data.signup_to : null;
        let client_status = data.client_status;
        if (client_status === "ALL") client_status = null;
        let user_type = null;
        if (data.user_type === "PORTABLE") user_type = 10;
        if (data.user_type === "INTERLOCK") user_type = 20;
        if (data.user_type === "PORTABLE_AND_INTERLOCK") user_type = 30;
        if (data.user_type === "ALL") user_type = 0;
        const payload = {
            creation_date_from,
            creation_date_to,
            client_status,
            user_type
        };
        await PostExportClientCSV(
            payload
        )
            .then((result) => {
        
            if (result.success) {
                toast.success(result.message);
                setDisableDownload(false);
            } else {
                toast.error(result.message);
                setDisableDownload(false);
            }
            })
            .catch((error) => {
            setDisableDownload(false);
            if (error.response.status == 401) {
                EmptyLocalStorage();
                history.push("/");
            } else {
                return toast.error(error.response.data.message);
            }
            });
    };

    return (
        <Form className="FormGenerateReport" onSubmit={handleSubmit(handleExportClientCSV)}>
            <div>
                <Form.Group controlId="signupFrom" className="mb-3">
                    <Form.Label>Signup Date From (OPTIONAL)</Form.Label>
                    <Form.Control
                        type="date"
                        {...register('signup_from')}
                    />
                </Form.Group>
                <Form.Group controlId="signupTo" className="mb-3">
                    <Form.Label>Signup Date To (OPTIONAL)</Form.Label>
                    <Form.Control
                        type="date"
                        {...register('signup_to')}
                    />
                </Form.Group>
                <Form.Group controlId="isActive" className="mb-3">
                    <Form.Label>Client Status</Form.Label>
                    <Form.Select {...register('client_status')}>
                        <option value="ALL">All</option>
                        <option value="ACTIVE">Active Users</option>
                        <option value="LOCKED">Locked Users</option>
                        <option value="DELETED">Deleted Users</option>
                    </Form.Select>
                </Form.Group>
                <Form.Group controlId="userType" className="mb-3">
                    <Form.Label>User Type</Form.Label>
                    <Form.Select {...register('user_type')}>
                        <option value="ALL">All Units</option>
                        <option value="PORTABLE_AND_INTERLOCK">Portable & Interlock Units</option>
                        <option value="PORTABLE">Portable Units</option>
                        <option value="INTERLOCK">Interlock Units</option>
                    </Form.Select>
                </Form.Group>
            </div>

            <Row>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Button
                        disabled={disableDownload}
                        type="submit"
                        className="btn btn-green-theme w-100 mt-3"
                    >
                        {disableDownload ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />{' '}
                                Downloading
                            </>
                        ) : (
                            'Export CSV'
                        )}
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default ExportClientCSVModalForm;
